<script>
  import { createEventDispatcher } from "svelte";
  import { Link } from "svelte-routing";
  import { tooltip } from "svelte-utilities";

  import CircleXIcon from "@local/assets/icons/circle-x.svg";
  import InfoIcon from "@local/assets/icons/info.svg";
  import SidebarSection from "./SidebarSection.svelte";
  import TextInput from "./TextInput.svelte";
  import FlagInput from "./FlagInput.svelte";
  import ContenteditableInput from "./ContenteditableInput.svelte";
  import LlmRequestInfo from "#lib/sidebar/LlmRequestInfo.svelte";
  import { drawingSrc as getDrawingSrc } from "#src/api";
  import { profile } from "#src/stores/auth.js";

  export let group;
  export let noteid = null;
  export let note;
  export let disabled;
  export let documentNotes;
  export let multiple = false;

  const dispatch = createEventDispatcher();

  let refreshKey = crypto.randomUUID();
  let llmRequestModal;

  $: drawingSrc = !multiple && note.drawing && getDrawingSrc(note.drawing);

  function updateNote(prop, value) {
    dispatch("updateNote", { id: note.id, prop, value });
  }

  function removeDrawing() {
    dispatch("updateNote", { id: note.id, prop: "drawing", value: null });
  }
</script>

{#if !multiple && note?.drawing}
  <SidebarSection>
    <div class="relative">
      <div class="flex items-center justify-center">
        {#key refreshKey}
          <div class="w-36 h-36 relative flex items-center justify-center">
            <img class="max-h-36 border border-gray-400" src={drawingSrc} alt="Note Drawing" />
          </div>
        {/key}
      </div>
      {#if !disabled}
        <button
          use:tooltip={{ text: "Remove Drawing" }}
          class="absolute top-0 right-0 text-gray-500 hover:text-black rounded p-1 hover:bg-gray-100"
          on:click|stopPropagation={removeDrawing}>
          <CircleXIcon />
        </button>
      {/if}
    </div>
  </SidebarSection>
{/if}
<SidebarSection>
  <h3 class="px-2 mb-2">Properties</h3>
  <div class="flex items-center gap-2">
    <TextInput
      label="Mark"
      {disabled}
      labelWidth="5.5rem"
      value={note.mark}
      on:input={(e) => updateNote("mark", e.detail.value)} />
    {#if !multiple && note.llm_request_log_id && $profile?.user_role === "developer"}
      <div class="flex items-center">
        <button
          class="p-1 rounded text-gray-500 hover:bg-gray-200"
          on:click={() => llmRequestModal.open(note.llm_request_log_id)}>
          <InfoIcon />
        </button>
      </div>
    {/if}
  </div>
  <TextInput
    label="Title"
    {disabled}
    labelWidth="5.5rem"
    value={note.title}
    on:input={(e) => updateNote("title", e.detail.value)} />
  <ContenteditableInput
    label="Body"
    {disabled}
    labelWidth="5.5rem"
    value={note.body}
    on:input={(e) => updateNote("body", e.detail.value)} />
  <FlagInput
    label="Flag"
    {disabled}
    labelWidth="5.5rem"
    value={note.approval_status}
    on:input={(e) => updateNote("approval_status", e.detail.value)} />
  <TextInput
    label="Scope"
    {disabled}
    labelWidth="5.5rem"
    value={note.scope}
    on:input={(e) => updateNote("scope", e.detail.value)} />
</SidebarSection>

<LlmRequestInfo bind:this={llmRequestModal} />
